import React from 'react'
import { FaCalendarAlt } from "react-icons/fa"; // using react-icons
import { NavLink } from 'react-router-dom';

const FloatingAppointmentButton = () => {
  return (
    <div>
      <NavLink
        to="/"
        onClick={(e) => {
          e.preventDefault();
          window.open(
            "https://bookings.cloud.microsoft/book/AdoreBijouxJewelers@NETORG3893906.onmicrosoft.com/?ismsaljsauthenabled",
            "_blank"
          );
        }}
        className="floating-appointment-btn"
      >
        <FaCalendarAlt style={{ marginRight: "8px" }} />
        Schedule an Appointment
      </NavLink>
    </div>
  )
}

export default FloatingAppointmentButton
